module.exports = __webpack_public_path__ + "static/media/ovalshape.199519d0.jpg";